<template>
  <div class="right-menu" v-if="$route.path === '/agenda'">
    <Search></Search>
    <Selection class="mr-auto ml-5"></Selection>
  </div>
</template>

<script>
  import Selection from './Selection.vue'
  import Search from './Search.vue'

  export default {
    components: {
      Selection,
      Search
    }
  }
</script>

<style scoped>
  .right-menu {
    display: flex;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/LeftMenu/LeftMenu.vue